import { render } from "./ApiTokenForm.vue?vue&type=template&id=e0204fb6"
import script from "./ApiTokenForm.vue?vue&type=script&lang=js"
export * from "./ApiTokenForm.vue?vue&type=script&lang=js"

import exportComponent from "/builds/fLte45evJ/0/trinax/jeopardy.trinax.se/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__